// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
const HUB_NAME = 'workflowmessagerelayhub';

// ============= Types =============
export interface SendUserTypingStateWorkflowSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  workflowId: string;
  userId: string;
  isTyping: boolean;
}

// ============= Main Function =============
/**
 * Sends user typing state via WorkflowMessageRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param workflowId The workflow ID
 * @param userId The ID of the user
 * @param isTyping Whether the user is typing
 * @returns Promise with API response or error
 */
export const sendUserTypingStateWorkflowSession = async ({
  invokeHub,
  workflowId,
  userId,
  isTyping,
}: SendUserTypingStateWorkflowSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Sending typing state for user [${userId}] in workflow [${workflowId}] via WorkflowMessageRelayHub...`
    );

    if (!workflowId) {
      throw new Error('workflowId is required');
    }
    if (!userId) {
      throw new Error('userId is required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'SendUserTypingStateAsync',
      workflowId,
      userId,
      isTyping
    );

    console.log(
      `✅ Typing state sent successfully for user [${userId}] in workflow [${workflowId}]`
    );
    return result;
  } catch (error) {
    console.error(
      `🔴 Error sending typing state for user [${userId}] in workflow [${workflowId}] via WorkflowMessageRelayHub:`,
      error
    );
    throw error;
  }
};
